import React from 'react';
import { BookOpen, MapPin, School } from 'lucide-react';

/**
 * Компонент с основными параметрами образования
 */
const EducationParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  educationLevels,
  universityTypes,
  universityLocations
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Уровень образования */}
      <div>
        <label htmlFor="educationLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <BookOpen className="w-4 h-4 mr-2 text-blue-500" />
          Уровень образования
        </label>
        <select
          id="educationLevel"
          name="educationLevel"
          value={formData.educationLevel}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.educationLevel ? 'input-error' : ''}`}
        >
          {educationLevels.map((level) => (
            <option key={level.id} value={level.id}>
              {level.name} ({level.years} {level.years === 1 ? 'год' : level.years < 5 ? 'года' : 'лет'})
            </option>
          ))}
        </select>
        {errors.educationLevel && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.educationLevel}
          </p>
        )}
      </div>

      {/* Тип учебного заведения */}
      <div>
        <label htmlFor="universityType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <School className="w-4 h-4 mr-2 text-blue-500" />
          Тип учебного заведения
        </label>
        <select
          id="universityType"
          name="universityType"
          value={formData.universityType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.universityType ? 'input-error' : ''}`}
        >
          {universityTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.universityType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.universityType}
          </p>
        )}
      </div>

      {/* Местоположение учебного заведения */}
      <div>
        <label htmlFor="universityLocation" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <MapPin className="w-4 h-4 mr-2 text-blue-500" />
          Местоположение
        </label>
        <select
          id="universityLocation"
          name="universityLocation"
          value={formData.universityLocation}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.universityLocation ? 'input-error' : ''}`}
        >
          {universityLocations.map((location) => (
            <option key={location.id} value={location.id}>
              {location.name}
            </option>
          ))}
        </select>
        {errors.universityLocation && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.universityLocation}
          </p>
        )}
      </div>

      {/* Лет до начала обучения */}
      <div>
        <label htmlFor="yearsUntilStart" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Лет до начала обучения
        </label>
        <input
          type="text"
          id="yearsUntilStart"
          name="yearsUntilStart"
          value={formData.yearsUntilStart}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.yearsUntilStart ? 'input-error' : ''}`}
          placeholder="Например, 5"
        />
        {errors.yearsUntilStart && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.yearsUntilStart}
          </p>
        )}
      </div>

      {/* Длительность обучения */}
      <div>
        <label htmlFor="educationDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Длительность обучения (в годах)
        </label>
        <input
          type="text"
          id="educationDuration"
          name="educationDuration"
          value={formData.educationDuration}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.educationDuration ? 'input-error' : ''}`}
          placeholder="Например, 4"
        />
        {errors.educationDuration && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.educationDuration}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Бакалавриат - 4 года, магистратура - 2 года, специалитет - 5-6 лет
        </p>
      </div>
    </div>
  );
};

export default EducationParametersSection;